export default {

    changeownactive({commit},person){
        commit("changeownactive",person);
    },
    changeactivename({commit},activename){
        commit("changeactivename",activename);
    }
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js